import East from "@mui/icons-material/East";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import format from "date-fns/format"; // GLOBAL CUSTOM COMPONENT
import Link from "next/link";
import { H5, Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography"; // Local CUSTOM COMPONENT
import { formatMoney } from "src/lib/utils";
import TableRow from "../table-row"; // CUSTOM UTILS LIBRARY FUNCTION
import { ORDER_STATUS, OrderResponse } from "src/lib/fetcher/client";

// =================================================
const OrderRow = ({ order }: { order: OrderResponse }) => {
  const getLabel = (status: ORDER_STATUS) => {
    switch (status) {
      case ORDER_STATUS.Pending:
        return "Shipping";
      case ORDER_STATUS.Confirmed:
        return "Confirmed";
      case ORDER_STATUS.Completed:
        return "Completed";
      case ORDER_STATUS.Cancelled:
        return "Cancelled";
      default:
        return "New";
    }
  };

  const getColor = (status: ORDER_STATUS) => {
    switch (status) {
      case ORDER_STATUS.Pending:
      case ORDER_STATUS.Confirmed:
        return "secondary";
      case ORDER_STATUS.Completed:
        return "success";
      case ORDER_STATUS.Cancelled:
        return "primary";
      default:
        return "default";
    }
  };

  return (
    <Link href={`/orders/${order.code}`}>
      <TableRow
        sx={{
          gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
        }}
      >
        <H5 ellipsis>#{order.code}</H5>

        <Box textAlign="center">
          <Chip size="small" label={getLabel(order.state)} color={getColor(order.status)} />
        </Box>

        <Paragraph
          textAlign={{
            sm: "center",
            xs: "left",
          }}
        >
          {format(new Date(order.createdAt), "MMM dd, yyyy")}
        </Paragraph>

        <Paragraph textAlign="center">{formatMoney(order.totalAmount)}</Paragraph>

        <Box
          display={{
            sm: "inline-flex",
            xs: "none",
          }}
          justifyContent="end"
        >
          <IconButton>
            <East
              fontSize="small"
              sx={{
                color: "grey.500",
                transform: ({ direction }) => `rotate(${direction === "rtl" ? "180deg" : "0deg"})`,
              }}
            />
          </IconButton>
        </Box>
      </TableRow>
    </Link>
  );
};

export default OrderRow;
